import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const IndonesiaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_14982'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_14982)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 7.46667H20V0H0V7.46667Z'
					fill='#E12237'
				/>
			</g>
		</svg>
	);
};

export default IndonesiaFlagIcon;
